import { render, staticRenderFns } from "./InputConsortium.vue?vue&type=template&id=4363fd1e&"
import script from "./InputConsortium.vue?vue&type=script&lang=js&"
export * from "./InputConsortium.vue?vue&type=script&lang=js&"
import style0 from "./InputConsortium.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports